import {call, put, takeLatest} from 'redux-saga/effects';
import PlayrateApi from '../../api/PlayrateApi';
import playrateActions from '../../actions/fortnite-game/playrate.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';
import {NO_DATA_ERROR_CODE} from './constants';

function* getPlayrate(action) {
    try {
        delete action.payload.silent;

        const {data} = yield call(PlayrateApi.getData, action.payload);

        yield put(
            playrateActions.getPlayrateSuccess({
                data,
                error: data && Object.keys(data).length ? undefined : NO_DATA_ERROR_CODE
            })
        );
    } catch (e) {
        yield put(playrateActions.getPlayrateFailed(getErrorCodeFromResponse(e), e));
    }
}

function* playrateSaga() {
    yield takeLatest(playrateActions.TYPES.GET_PLAYRATE, getPlayrate);
}

export default playrateSaga;
